<template>
    <div>
        <sticky :className="'sub-navbar draft'">
            <el-button v-loading="saveLoading" type="primary" @click="save">保存</el-button>
        </sticky>

        <div style="padding: 10px;">
            <el-card class="box-card" style="width: 50%;">
                <div slot="header" class="clearfix">
                    <span>角色明细</span>
                </div>
                <el-form ref="form" :model="record" :rules="formRules" label-width="80px">
                    <el-form-item label="名称" prop="name">
                        <el-input style="width: 300px" v-model="record.name" :disabled="record.systemd === 1"></el-input>
                    </el-form-item>
                    <el-form-item label="角色类型" prop="roleType">
                        <el-select style="width: 200px" class="filter-item" v-model="record.roleType" disabled>
                            <el-option v-for="[value, label] in roleTypeMap" :key="value" :label="label" :value="value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="人管角色" :prop="!isBackendRole ? 'rgRole' : ''" v-if="!isBackendRole">
                        <el-select style="width: 200px" class="filter-item" v-model="record.rgRole" multiple>
                            <el-option v-for="item in rgList" :key="item.id" :label="item.roleName" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input type="textarea" style="width: 300px" v-model="record.remark"></el-input>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-col :span="8">
                            <el-select style="width: 200px" class="filter-item" v-model="record.status">
                                <el-option label="正常" :value="0">
                                </el-option>
                                <el-option label="冻结" :value="-1">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-form-item>
                </el-form>
            </el-card>
            <el-row style="margin-top:20px;">
                <el-col :span="8" style="padding-right: 10px;">
                    <el-card class="box-card" v-if="isBackendRole">
                        <div slot="header" class="clearfix">
                            <span>运营管理平台</span>
                        </div>
                        <el-tree ref="tree1" key="tree1" node-key="id" :data="list1" :props="defaultProps" highlight-current default-expand-all show-checkbox check-strictly expand-on-click-node></el-tree>
                    </el-card>
                    <el-card class="box-card" v-else>
                        <div slot="header" class="clearfix">
                            <span>经销商系统</span>
                        </div>
                        <el-tree ref="tree2" key="tree2" :data="modules" :props="modulesProps" show-checkbox expand-on-click-node node-key="id"></el-tree>
                    </el-card>
                </el-col>
            </el-row>

        </div>
    </div>
</template>

<script>
import Sticky from "@/components/Sticky"; // 粘性header组件
import { roleTypeMap } from "./constants.js"
export default {
    name: "SystemRoleEdit",
    components: {
        Sticky
    },
    data() {
        return {
            roleTypeMap,
            id: "",
            saveLoading: false,
            record: {
                name: '',
                remark: '',
                roleType: 1,
                rgRole: [],
            },
            list1: [],
            list2: [],
            defaultProps: {
                children: 'subs',
                label: 'name'
            },
            modulesProps: {
              children: 'nodes',
              label: 'name'
            },
            formRules: {
                name: [{
                    required: true,
                    message: '请输入名称',
                    trigger: 'blur'
                }, {
                    min: 1,
                    max: 50,
                    message: '长度应在1-50位',
                    trigger: 'blur'
                }],
                roleType: [{
                    required: true,
                    message: '请选择角色类型',
                    trigger: 'blur'
                }],
                rgRole: [{
                    required: true,
                    message: '请选择人管角色',
                    trigger: 'blur'
                }],
            },
            rgList: [], // 人管角色
            modules: [], // 店端菜单
        };
    },
    computed: {
      // 是否厂端角色
      isBackendRole() {
        console.log(this.record.roleType, this.record.roleType === 1, '================')
        return this.record.roleType === 1
      }
    },
    async activated() {
        await this.getSysFunctions()
        this.id = parseInt(this.$route.params.id)
        this.retrieveDetail()
        this.getRgList()
        this.retrieveSystemData()
    },
    methods: {
        retrieveDetail() {
            this.$httpAuth
                .post("/v1/backendRoleRpc/get", {
                    id: this.id,
                })
                .then((response) => {
                    const { rgRole, ...rest } = response.data.data
                    this.record = {
                        ...rest,
                        rgRole: rgRole ? rgRole.split(',').map(n=> Number(n)) : []
                    }
                    if (this.isBackendRole) {
                        const role = JSON.parse(this.record.role)
                        this.$refs.tree1.setCheckedKeys(role.PT1);
                    } else {
                      const keys = JSON.parse(this.record.role).PT2
                      this.$nextTick(() => {
                        this.$refs.tree2.setCheckedKeys(keys)
                      })
                    }
                })
        },
        save() {
            this.$refs['form'].validate((valid) => {
              if (valid) {
                const { name, roleType, rgRole, remark, status } = this.record;
                const role = {}
                if(this.isBackendRole) {
                  const checkedNodes1 = this.$refs.tree1.getCheckedNodes()
                  role.PT1 = []
                  for (const i of checkedNodes1) {
                    role.PT1.push(i.id)
                  }
                } else {
                  const checkedNodes2 = this.$refs.tree2.getCheckedNodes()
                  role.PT2 = []
                  for (const i of checkedNodes2) {
                    role.PT2.push(i.id)
                  }
                }
                    this.saveLoading = true;
                    this.$httpAuth
                        .post("/v1/backendRoleRpc/update", {
                            id: this.id,
                            name,
                            roleType,
                            rgRole: this.isBackendRole ? '' : rgRole.toString(),
                            remark,
                            role: JSON.stringify(role),
                            status,
                        })
                        .then((response)=> {
                            this.saveLoading = false;
                            this.$alert("保存成功", "编辑角色", {
                                confirmButtonText: "关闭",
                                callback: action => {
                                    this.$store.dispatch("delCurrentView");
                                    this.$router.push("/system/role/list");
                                }
                            });
                        })
                        .catch(() => {
                            this.saveLoading = false;
                        });
                }
            });
        },
        async getSysFunctions() {
            await this.$httpAuth
                .post("/v1/backendFunctionRpc/list", {
                    pageStart: 0,
                    pageCount: 1000,
                    sys: 'PT1',
                    status: 0,
                    key: ""
                })
                .then((response) => {
                    this.list1 = response.data.data
                })
                .catch(() => {
                    this.listLoading = false;
                });
        },
        getRgList() {
            this.$httpAuth
               .post('/v1/backendRoleRpc/rgList')
                   .then((response) => {
                     this.rgList = response.data.data
                   })
                   .catch(() => {
                   })
        },
        retrieveSystemData() {
          this.$httpAuth.post("/v1/baseRpc/info", {}).then((res) => {
            const { modules = [] } = res.data;
            this.modules = modules.filter(
              (item) =>
                !["智蛛锐见", "签到", "库存", "即客", "企业微信"].includes(
                  item.name
                )
            );
          });
        },
        handleCheckChange(data, checked, indeterminate) {
            // console.log(data, checked, indeterminate);
            console.log(this.$refs.tree1.getCheckedNodes());
        },
    }
};
</script>

<style>

</style>
